import * as yup from 'yup';
import { PHONE_REGEX } from '../../../constants/regex';
import { MOBILE_PHONE_REQUIRED } from '../../../constants/field-error-messages';
import { additionalApproversValidation } from '../../shared/validation/ma-validation';

export const validationSchema = yup.object().shape({
  t2cCheckbox: yup.boolean(),
  phoneNumber: yup.string().when(['t2cCheckbox', 'hasMultipleApprovers'], {
    is: (t2cCheckbox: boolean, hasMultipleApprovers: boolean) => {
      return t2cCheckbox && !hasMultipleApprovers;
    },
    then: yup
      .string()
      .required(MOBILE_PHONE_REQUIRED)
      .matches(PHONE_REGEX, MOBILE_PHONE_REQUIRED),
  }),
  additionalApprovers: yup
    .array()
    .when(['t2cCheckbox', 'hasMultipleApprovers'], {
      is: (t2cCheckbox: boolean, hasMultipleApprovers: boolean) => {
        return t2cCheckbox && hasMultipleApprovers;
      },
      then: additionalApproversValidation,
    }),
});
